import { render, staticRenderFns } from "./warehousePurchaseInfo.vue?vue&type=template&id=2986f822&scoped=true&"
import script from "./warehousePurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./warehousePurchaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./warehousePurchaseInfo.vue?vue&type=style&index=0&id=2986f822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986f822",
  null
  
)

export default component.exports